import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithRestApiByRequestUid,
} from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { buildEstimatedTradeCostComparisonWidgetConfigSlice } from './store/configslice';
import { EstimatedTradeCostRequest } from 'widgets/estimatedTradeCost/store/data/EstimatedTradeCostRequest';
import { EstimatedTradeCostApiResponse } from 'widgets/estimatedTradeCost/api/EstimatedTradeCostApiResponse';
import { EstimatedTradeCostComparisonConfigState } from 'widgets/estimatedTradeCost/widget-comparison/store/EstimatedTradeCostComparisonConfigState';
import { EstimatedTradeCostComparisonWidget } from 'widgets/estimatedTradeCost/widget-comparison/components/EstimatedTradeCostComparisonWidget';
import { estimatedTradeCostComparisonDescription } from './components/description/estimatedTradeCostComparisonDescription';
import { estimatedTradeCostComparisonStreamConfig } from 'widgets/estimatedTradeCost/widget-comparison/stream-config';

const { initialConfigState } =
    buildEstimatedTradeCostComparisonWidgetConfigSlice();

export const estimatedTradeCostComparisonWidgetStrategy: WidgetStrategyWithConfig<EstimatedTradeCostComparisonConfigState> &
    WidgetStrategyWithRestApiByRequestUid<
        EstimatedTradeCostRequest,
        EstimatedTradeCostApiResponse
    > = {
    title: 'Pre-Trade Cost Comparison',
    supportedHosts: ['layout'],
    reactComponentType: EstimatedTradeCostComparisonWidget,
    categories: [WidgetCategory.SINGLE_STOCK],
    description: estimatedTradeCostComparisonDescription,
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.ExactlyOneOrder,
    initialConfigState,
    managedStreamConfig: estimatedTradeCostComparisonStreamConfig,
    getRequiredOrderColumns: () => ['rem'],
};
